import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getIReceivableURL } from "@TKCCP/Services/IReceivableService";
import { CreateUserAccountParameter, getCreateUserAccount } from "@TKCCP/Services/tkccpCreateUserAccountService";
import { CreateUserAccountModel } from "@TKCCP/Types/ApiModels";

type ReceivableParameter = HasOnSuccess<string>;

type HandlerType = ApiHandler<ReceivableParameter, string>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();
    props.apiParameter = props.parameter;
};

export const GetReceivableURL: HandlerType = async props => {
    const currentdate = new Date(); 
    
        const datetime = `${currentdate.getDate()}-${
                         currentdate.getMonth()+1}-${ 
                         currentdate.getFullYear()}T${  
                         currentdate.getHours()}-${  
                         currentdate.getMinutes()}-${ 
                         currentdate.getSeconds()}`;

    props.apiResult = await getIReceivableURL(datetime);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, GetReceivableURL, ExecuteOnSuccessCallback];

const receivableURL = createHandlerChainRunner(chain, "ReceivableURL");
export default receivableURL;
